import React, { useState } from 'react';

const languages = [
    {
        code: 'en',
        name: 'English',
        elementName: 'English',
        flag: 'assets/img/icon/in.png'
    },
    {
        code: 'pt',
        name: 'Português',
        elementName: 'Portuguese (Brazil)',
        flag: 'assets/img/icon/po.png'
    },
    {
        code: 'es',
        name: 'Espanhol',
        elementName: 'Spanish',
        flag: 'assets/img/icon/es.png'
    },
    {
        code: 'fr',
        name: 'Francês',
        elementName: 'French',
        flag: 'assets/img/icon/fr.png'
    },
    {
        code: 'es-mx',
        name: 'Espanhol (Mex)',
        elementName: 'Spanish',
        flag: 'assets/img/icon/mx.png'
    }
];

const LanguageDropdown = () => {
    // Google Translate integration removed/commented out.
    // Previous implementation read the `googtrans` cookie to determine
    // the current language. Keep a simple default instead.
    const getCurrentLanguage = () => {
        return 'pt'; // default to Portuguese
    };

    const [isOpen, setIsOpen] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(() => {
        const currentCode = getCurrentLanguage();
        return languages.find(lang => lang.code === currentCode) || {
            code: 'pt',
            name: 'Português',
            elementName: 'Portuguese (Brazil)',
            flag: 'assets/img/icon/po.png'
        };
    });

    const handleLanguageSelect = (language) => {
        changeLanguage(language);
        setSelectedLanguage(language);
        setIsOpen(false);
    };

    function getElementByXpath(xpathExpression) {
        const result = document.evaluate(
            xpathExpression,
            document, // contextNode: usually the document itself
            null, // namespaceResolver: null for HTML documents
            XPathResult.FIRST_ORDERED_NODE_TYPE, // resultType: returns the first matching node
            null // result: optional, existing result object
        );
        return result.singleNodeValue; // returns the single matching node
    }

    // Translation switching disabled. Keep as a no-op to avoid
    // performing cookie writes or reloads.
    const changeLanguage = (langCode) => {
        try {
            console.warn('changeLanguage: Google Translate integration disabled. Requested:', langCode);
        } catch (error) {
            console.error("Error in changeLanguage (noop):", error);
        }
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="language-dropdown">
            <button
                className="language-trigger"
                onClick={toggleDropdown}
                aria-expanded={isOpen}
                disabled
            >
                <img
                    src={selectedLanguage.flag}
                    alt={selectedLanguage.name}
                    className="flag-icon"
                />
                <svg
                    className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                >
                    <path d="M7 10l5 5 5-5z" />
                </svg>
            </button>

            {isOpen && (
                <div className="language-dropdown-menu">
                    {languages.map((language) => (
                        <button
                            key={language.code}
                            className={`language-option ${selectedLanguage.code === language.code ? 'selected' : ''}`}
                            onClick={() => handleLanguageSelect(language)}
                        >
                            <img
                                src={language.flag}
                                alt={language.name}
                                className="flag-icon-small"
                            />
                            <span className="language-name">{language.name}</span>
                        </button>
                    ))}
                </div>
            )}

            {isOpen && <div className="dropdown-overlay" onClick={() => setIsOpen(false)} />}
        </div>
    );
};

export default LanguageDropdown;